import { AreaSize } from '../types';

export function getSize(
  width: number,
  height: number,
  sizeBounds: Array<{ size: AreaSize; bounds: [width: number, height: number] }>,
): AreaSize {
  const suiteBounds = sizeBounds.find(({ bounds }) => width >= bounds[0] && height >= bounds[1]);

  return suiteBounds ? suiteBounds.size : 'hidden';
}
